module.exports = __webpack_public_path__ + "img/221121-bimistock-------1@1x.81dca37e.png";